/* global axios */
import ApiClient from './ApiClient';

class SummaryReportsAPI extends ApiClient {
  constructor() {
    super('summary_reports', { accountScoped: true, apiVersion: 'v2' });
  }

  getTeamReports({ since, until, businessHours } = {}) {
    return axios.get(`${this.url}/team`, {
      params: {
        since,
        until,
        business_hours: businessHours,
      },
    });
  }

  getAgentReports({ since, until, businessHours } = {}) {
    return axios.get(`${this.url}/agent`, {
      params: {
        since,
        until,
        business_hours: businessHours,
      },
    });
  }

  getInboxReports({ since, until, businessHours } = {}) {
    return axios.get(`${this.url}/inbox`, {
      params: {
        since,
        until,
        business_hours: businessHours,
      },
    });
  }

  getLabelReports({ since, until, businessHours } = {}) {
    return axios.get(`${this.url}/label`, {
      params: {
        since,
        until,
        business_hours: businessHours,
      },
    });
  }

  getContactReports({
    since,
    until,
    businessHours,
    inboxId,
    teamId,
    agentIds,
    ranking,
  } = {}) {
    return axios.get(`${this.url}/contact`, {
      params: {
        since,
        until,
        business_hours: businessHours,
        inbox_id: inboxId,
        team_id: teamId,
        agent_ids: agentIds,
        ranking,
      },
    });
  }

  getCompanyReport({
    companyId,
    since,
    until,
    businessHours,
    inboxId,
    teamId,
    agentIds,
  } = {}) {
    return axios.get(`${this.url}/company/${companyId}`, {
      params: {
        since,
        until,
        business_hours: businessHours,
        inbox_id: inboxId,
        team_id: teamId,
        agent_ids: agentIds,
      },
    });
  }

  getContactAiSummary({
    companyId,
    contactId,
    since,
    until,
    businessHours,
    inboxId,
    teamId,
    agentIds,
  } = {}) {
    return axios.get(
      `${this.url}/company/${companyId}/contacts/${contactId}/ai_summary`,
      {
        params: {
          since,
          until,
          business_hours: businessHours,
          inbox_id: inboxId,
          team_id: teamId,
          agent_ids: agentIds,
        },
      }
    );
  }
}

export default new SummaryReportsAPI();
